<span class="block md:hidden relative">
  <lds-button
    [size]="Size.MD"
    [iconOnly]="filtersIcon"
    [variant]="ButtonVariant.SECONDARY"
    (click)="openFiltersView()"
    class="relative"
  >
  </lds-button>
  @if (filtersCount() > 0) {
    <lds-badge
      [size]="Size.SM"
      [type]="BadgeType.FLAT"
      [color]="BadgeColor.GRAY"
      class="text-caption-mobile absolute -top-3 -right-3 pointer-events-none"
      [aria-label]="('filters' | translate) + filtersCount()"
    >
      {{ filtersCount() }}
    </lds-badge>
  }
</span>
<span class="hidden md:block">
  <lds-button
    [variant]="ButtonVariant.SECONDARY"
    [expand]="ButtonExpand.FULL"
    [iconLeft]="filtersIcon"
    (click)="openFiltersView()"
    [aria-label]="'filter' | translate"
  >
    {{ 'filter' | translate }}
    @if (filtersCount() > 0) {
      <span class="text-gray-70 font-medium">&nbsp;({{ filtersCount() }}) </span>
    }
  </lds-button>
</span>
